import { Accordion, Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconCalendar } from "@tabler/icons-react";
import { parseDate } from "../../../../../../functions/dates";
import { IconLinkedin } from "../../../../../../components/Icons/IconLinkedin";
import { IconEmail } from "../../../../../../assets/icons/IconEmail";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import TabAnswersItemMobile from "./TabAnswersItemMobile";

const AnswersGroupMobile = ({
  groupIndex,
  campaign,
  about,
  prospect,
  setProspect,
  currentContainer,
  setLoading,
}) => {
  const lang = useLanguage((s) => s.language);
  const isLinkedin = campaign.replies.some((x) => x.type === "linkedin");
  const allLinkedinReplies = campaign.replies.filter(
    (x) => x.type === "linkedin" && x.history_type === "reply"
  );
  const lastLinkedinReply = allLinkedinReplies?.[allLinkedinReplies.length - 1];

  const defaultLinkedinSender = campaign.replies.find(
    (x) => !!x?.reply_to?.integration_id
  );

  return (
    <Accordion variant="contained" mb={0} defaultValue={`${campaign.id}`}>
      <Accordion.Item value={`${campaign.id}`}>
        <Accordion.Control bg={isLinkedin ? "primary.0" : "orange.0"} h={52}>
          <Group>
            {/* {campaign?.name !== "Unlinked Activities" ? (
              <ThemeIcon
                variant="subtle"
                color={isLinkedin ? "primary" : "orange.4"}
              >
                {isLinkedin ? (
                  <IconLinkedin size={16} />
                ) : (
                  <IconEmail size={16} />
                )}
              </ThemeIcon>
            ) : (
              <ThemeIcon variant="subtle">
                <IconCalendar />
              </ThemeIcon>
            )} */}
            <Stack gap={2}>
              {campaign.hasMultipleDays ? (
                <Text size="sm">
                  {lang.leads.tabs.conversations} :{" "}
                  <span>
                    {parseDate(campaign.replies?.[0]?.date)} -{" "}
                    {parseDate(
                      campaign.replies?.[campaign.replies.length - 1]?.date
                    )}
                  </span>
                </Text>
              ) : (
                <Text size="sm">
                  {lang.leads.tabs.conversations} :{" "}
                  {parseDate(campaign.replies?.[0]?.date)}
                </Text>
              )}

              {campaign?.programmation_id &&
                campaign?.programmation_id !== "null" && (
                  <Text size="xs">
                    {campaign?.workflow_name || ""} #
                    {campaign?.programmation_id}{" "}
                  </Text>
                )}
            </Stack>
          </Group>
        </Accordion.Control>

        <Accordion.Panel styles={{ content: {padding: 8} }}>
          {campaign.replies.map((item, index) => (
            <TabAnswersItemMobile
              index={index}
              key={index}
              item={item}
              type={item.type}
              about={about}
              current={prospect}
              setCurrent={setProspect}
              container={currentContainer}
              setLoading={setLoading}
              isLast={index === campaign?.replies?.length - 1}
              lastLinkedinReply={lastLinkedinReply}
              defaultLinkedinSender={
                defaultLinkedinSender
                  ? {
                      id: defaultLinkedinSender.reply_to.integration_id,
                      is_valid: true,
                    }
                  : null
              }
              hideCampaign
              isOnly={groupIndex === 0 && index === 0}
            />
          ))}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default AnswersGroupMobile;
